<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAddBank"
        class="bg-black fixed h-screen bg-opacity-70 inset-0 z-50 w-full"
      >
        <form
          @submit.prevent="addBankDetail"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full overflow-y-auto"
          style="height: auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Add Bank Details</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <div class="p-4 grid grid-cols-2 gap-4">
            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Bank Name</label>
                <select
                  v-model="info.BankName"
                  required
                  class="p-2 bg-gray-200 rounded-md w-full"
                >
                  <option value="" disabled selected>Select Bank</option>
                  <option v-for="bank in banks" :value="bank" :key="bank">
                    {{ bank }}
                  </option>
                </select>
              </div>
            </div>

            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Account Name</label>
                <input
                  v-model="info.AccountName"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Account Number</label>
                <input
                  v-model="info.AccountNumber"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>

            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Branch</label>
                <input
                  v-model="info.Branch"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>

            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Branch Code</label>
                <input
                  v-model="info.BranchCode"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>

            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Swift Code</label>
                <input
                  v-model="info.SwiftCode"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-md px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { kenyanBanks } from "@/utils/utilsData";
export default {
  name: "AddBank",
  props: ["showAddBank", "reload", "data"],
  loading: false,
  create_success: null,
  create_error: null,
  display: false,
  showStatus: false,
  data() {
    return {
      info: {
        EmployeeId: this.getCurrentEmployeeId,
        BankName: "",
        AccountName: "",
        AccountNumber: "",
        Branch: "",
        BranchCode: "",
        SwiftCode: "",
      },
      banks: [],
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
    ]),
  },
  created() {
    // //console.log(this.data, this.title, this.reload)
    this.banks = kenyanBanks;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleSubmit() {
      setTimeout(() => {
        this.close();
      }, 1000);
    },

    // /{organization}/employee/bank/v1/edit
    addBankDetail() {
      this.info.EmployeeId = this.getCurrentEmployeeId;
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .put(
          `${this.getOrganization}/employee/bank/${this.$ApiVersion}/edit`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.reload();
              this.create_success = response.data.StatusMessage;
              this.info = {
                EmployeeId: this.getCurrentEmployeeId,
                BankName: "",
                AccountName: "",
                AccountNumber: "",
                Branch: "",
                BranchCode: "",
                SwiftCode: "",
              };
              setTimeout(() => {
                this.$emit("closeOnSuccess", response.data.StatusMessage);
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
